// Dashboards and configs as every library page shows them: what kind, where from, how big, and its picture.
import type { components } from '@tune/shared';

type Source = components['schemas']['Source'] | components['schemas']['SharedItem']['source'];

export function kindWord(kind: 'dashboard' | 'config'): string {
  return kind === 'dashboard' ? 'Dashboard' : 'Config';
}

/** Where an item comes from, as the MFD's Dashboards page says it. */
export function sourceWords(source: Source): string {
  switch (source.kind) {
    case 'tune':
      return 'TUNE';
    case 'group':
      return `TUNE, for ${source.group}`;
    case 'own':
      return 'Yours';
    case 'shared':
      return `Shared by ${source.sharedBy}`;
  }
}

/** Bytes as people read them: "840 KB", "12.4 MB", "1 GB" (a GB being 1,024 MB, as the quotas count). */
export function size(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} bytes`;
  }
  const units = ['KB', 'MB', 'GB'];
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit++;
  }
  return `${value.toLocaleString('en-AU', { maximumFractionDigits: value < 10 ? 1 : 0 })} ${units[unit]}`;
}

/** An item's picture: a dashboard's thumbnail, or a plain tile for a config or a dashboard without one. */
export function Thumb({ url, kind }: { url: string | null; kind: 'dashboard' | 'config' }) {
  if (url) {
    return <img className="thumb" src={url} alt="" width={160} height={80} loading="lazy" />;
  }
  return (
    <span className="thumb thumb--empty" aria-hidden="true">
      {kind === 'dashboard' ? 'Dashboard' : 'Config'}
    </span>
  );
}

/** Opens a file at the address the API gave: the browser saves it. */
export function fetchFile(url: string): void {
  window.location.assign(url);
}
